import React from 'react';
import PropTypes from 'prop-types';

import FpToaster from 'forepaas/toaster';
import FpTranslate from 'forepaas/translate';
import FpPasswordStrength from '../FpPasswordStrength.jsx';
import '../styles/FpNewPasswordRequired.less';

class FpNewPasswordRequired extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      form: {
        newPassword: '',
        confirmPassword: ''
      },
      policies: false,
      isLoading: false
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  handleInputChange(event) {
    if (event.target && event.target.value !== undefined) {
      const target = event.target;
      const value = target.value;
      const name = target.name;
      const form = { ...this.state.form };
      form[name] = value;
      this.setState({ form });
    } else if (typeof event === 'string') {
      // Handle password from FpPasswordStrength
      const form = { ...this.state.form };
      form.newPassword = event;
      this.setState({ form });
    }
  }

  canSubmit() {
    const { newPassword, confirmPassword } = this.state.form;
    const { policies, isLoading } = this.state;

    return (
      newPassword.length > 0 &&
      newPassword === confirmPassword &&
      policies &&
      !isLoading
    );
  }

  getRepeatClass() {
    let repeatClass = '';
    const { newPassword, confirmPassword } = this.state.form;

    // Only apply classes if the confirm password field has content
    if (confirmPassword !== '') {
      if (newPassword !== '' && newPassword !== confirmPassword) {
        repeatClass += 'error';
      } else if (newPassword !== '' && newPassword === confirmPassword) {
        repeatClass += 'success';
      }
    }

    return repeatClass;
  }

  setPolicies = (check) => {
    if (check !== this.state.policies) {
      this.setState({ policies: check });
    }
  }

  handleSubmit(event) {
    event.preventDefault();

    if (this.canSubmit()) {
      this.setState({ isLoading: true });

      const { newPassword } = this.state.form;

      // Call the completeNewPassword method passed from parent
      this.props.onCompletePassword(newPassword)
        .then(() => {
          this.setState({ isLoading: false });
          // Success message is handled by afterLoginSuccess in parent component
        })
        .catch(err => {
          this.setState({ isLoading: false });
          FpToaster.error(err.message || FpTranslate('Password change failed'));
        });
    }
  }

  render() {
    const repeatClass = this.getRepeatClass();

    const brand = this.props.brand || 'cloom';
    const logoSrc = brand === 'roomai' ? '/assets/img/roomai-logo.png' : '/assets/img/cloom-logo.png';
    const logoAlt = brand === 'roomai' ? 'RoomAI Logo' : 'Cloom Logo';

    return (
      <div className={`new-login-container ${brand === 'roomai' ? 'brand-roomai' : 'brand-cloom'}`}>
        {/* Left Panel - Logo and Maintenance Notice */}
        <div className="login-left-panel">
          <div className="logo-section">
            <div className="cloom-logo">
              <img src={logoSrc} alt={logoAlt} className="logo-image" />
            </div>
            {process.env.REACT_APP_ENV_TYPE !== 'prod' && (
              <div className="environment-text">{'開発環境'}</div>
            )}
          </div>
          <div className="version-info">Version: {process.env.REACT_APP_VERSION}</div>
        </div>

        {/* Right Panel - New Password Form */}
        <div className="login-right-panel">
          <div className="login-form-container">
            <h1 className="login-title">パスワードリセット</h1>
            <form className="login-form" onSubmit={this.handleSubmit}>
              <div className="form-group">
                <FpPasswordStrength
                  onChange={this.handleInputChange}
                  minScore={2}
                  setPolicies={this.setPolicies}
                  policies={this.state.policies}
                />
              </div>
              <div className="form-group">
                <label className="form-label" style={{ color: this.props.color }}>
                  {FpTranslate('settingsConfirmNewPassword')}
                </label>
                <input
                  onChange={this.handleInputChange}
                  type="password"
                  name="confirmPassword"
                  placeholder="新しいパスワード"
                  className={`form-input ${repeatClass}`}
                />
                {repeatClass === 'error' && (
                  <p className="error-info">{FpTranslate('settingsPasswordDontMatch')}</p>
                )}
              </div>
              <button
                className="login-button"
                type="submit"
                disabled={!this.canSubmit()}
              >
                送信
              </button>

              <div className="forgot-password-container" style={{ marginTop: 'unset' }}>
                <span
                  role="button"
                  tabIndex={0}
                  onClick={this.props.onCancel}
                  onKeyDown={e => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      e.preventDefault();
                      this.props.onCancel();
                    }
                  }}
                  className="forgot-password-link"
                  style={{ display: 'inline' }}
                >
                  キャンセル
                </span>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

FpNewPasswordRequired.propTypes = {
  color: PropTypes.string,
  onCompletePassword: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  brand: PropTypes.string,
};

export default FpNewPasswordRequired; 